import Cookies from 'js-cookie'
import {Constant} from '../../common/constant'
import * as types from '../mutation-types'

const TOKEN_NAME = Constant.TOKEN_NAME
const REFRESH_TOKEN = Constant.REFRESH_TOKEN
const EDIT_PERMISSIONS = Constant.EDIT_PERMISSIONS
const READ_PERMISSIONS = Constant.READ_PERMISSIONS
const MENU_PERMISSIONS = Constant.MENU_PERMISSIONS
const APP_USR = Constant.APP_USR

const state = {
  main: {
    user_info: Cookies.get(APP_USR) ? JSON.parse(Cookies.get(APP_USR)) : null,
    token: Cookies.get(TOKEN_NAME) ? Cookies.get(TOKEN_NAME) : null,
    refresh: Cookies.get(REFRESH_TOKEN) ? Cookies.get(REFRESH_TOKEN) : null,
    edit_permissions: Cookies.get(EDIT_PERMISSIONS) ? Cookies.get(EDIT_PERMISSIONS) : null,
    read_permissions: Cookies.get(READ_PERMISSIONS) ? Cookies.get(READ_PERMISSIONS) : null,
    menu_permissions: Cookies.get(MENU_PERMISSIONS) ? Cookies.get(MENU_PERMISSIONS) : null,
  }
}

const mutations = {
  [types.LOGIN] (state, {token, refresh}) {
    state.main.token = token
    state.main.refresh = refresh
  },
  [types.UPDATE_USER] (state, {userInfo}) {
    state.main.user_info = userInfo
  },
  [types.UPDATE_MENU] (state, {menu_permissions}) {
    state.main.menu_permissions = menu_permissions
  },
  [types.UPDATE_PERMISSION] (state, {edit_permissions, read_permissions}) {
    state.main.edit_permissions = edit_permissions
    state.main.read_permissions = read_permissions
  },
  [types.LOGOUT] (state) {
    state.main.user_info = null
    state.main.token = null
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js